<template>
  <div class="medical-detail">
    <!-- 基本信息 -->
    <a-card size="small">
      <template #title><b>病案基本信息</b></template>
      <DetailInfo :formLayout="formLayout" :columnNum="3" />
    </a-card>
    <!-- 病案详细记录 -->
    <a-card size="small" style="margin-top: 8px;">
      <template #title><b>病案详细记录</b></template>
      <OnlCgformAutoList ref="table"
                         :code-key="codeKey"
                         class="list-box"
                         :searchParams="searchParams"
                         :isShowSearch="false"
                         :isShowTools="false">
        <template #toolsLeft>
          <a-button @click="handleAdd" type="primary" icon="plus" style="margin-bottom: 10px">诊断&处方</a-button>
        </template>
      </OnlCgformAutoList>
    </a-card>
    <!-- 在线表单新增编辑模态框组件 -->
    <onl-cgform-auto-modal ref="addModal"
                           @success="handleFormSuccess"
                           :code="codeKey"
                           :mainData="baseInfo" />
  </div>
</template>

<script>
import DetailInfo from '@comp/DetailInfo/DetailInfo'
import { detailInfo } from '@views/pages/medicalDetail/medicalDetailConfig'
import OnlCgformAutoList from '@views/modules/online/cgform/auto/OnlCgformAutoList'
import OnlCgformAutoModal from '@views/modules/online/cgform/auto/OnlCgformAutoModal'
import { medicalRecordQueryById } from '@api/online'

export default {
  name: 'medicalDetail',
  title: '病案记录详情',
  components: { DetailInfo, OnlCgformAutoList, OnlCgformAutoModal },
  props: {
    detailData: {
      type: Object
    }
  },
  data() {
    return {
      // 病案详细记录表id
      codeKey: 'ff80808183e3bc840183e4a405760000',
      // 基本信息
      formLayout: [],
      // 诊断记录列表的查询条件
      searchParams: {},
      tableSetting: {
        isShowAlert: false,
        isShowTools: false
      },
      // 基础信息
      baseInfo: {},
      formTemplate: '2'
    }
  },
  created() {
    this.getDetailInfo()
  },
  methods: {
    // 新建处方
    handleAdd() {
      this.$refs.addModal.add(this.formTemplate)
    },
    // 表单新建成功后回调
    handleFormSuccess() {
      this.$refs.table.handleFormSuccess()
    },
    // 获取详情信息接口
    getDetailInfo() {
      medicalRecordQueryById({ id: this.detailData.id }).then(res => {
        let data = res.result
        if (!data) return
        this.baseInfo = data
        this.formLayout = this.changeDetailInfo(data)
        data.id && (this.searchParams = {
          medical_id: data.id
        })
      })
    },
    // 转换详情数据
    changeDetailInfo(data) {
      if (!data) return
      let arr = []
      detailInfo.forEach(ele => {
        let value = data[ ele.field ]
        if(ele.field === 'animalId_dictText') {
          let str = data.animalNickname? ` | ${data.animalNickname}` : ''
          value = data[ ele.field ] + str
        }
        arr.push({ ...ele, value })
      })
      return arr
    }
  }
}
</script>

<style scoped lang="less">
.medical-detail {
  .list-box {
    /deep/ .ant-card-body {
      padding: 0 !important;
    }
  }

}
</style>